import * as c from '@chakra-ui/react'
import { useLocation } from 'react-router'
import { useNavigate } from 'react-router-dom'
import { HousiLogoIconMobile } from 'src/assets/icons/nav/housi-logo-mobile.icon'
import { useSearch } from 'src/components/search-v2/search-context'

import MenuDrawerV2 from '../mobile-v2/menuDrawer'
import SearchButton from '../mobile-v2/searchButton'

const NavbarMobile = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { valid } = useSearch()

  const { isOpen, onClose, onToggle } = c.useDisclosure()

  const [isMobile] = c.useMediaQuery(['(max-width: 768px)'])

  const isClosedNavbar = location.search.includes('navbar=false')

  if (!isMobile) return null
  if (valid.open) return null
  if (isClosedNavbar) return null

  return (
    <c.Flex
      position="fixed"
      top="0"
      zIndex={9999}
      bg="black.0"
      display={{ base: 'flex', md: 'none', lg: 'none' }}
      align="center"
      justify="space-between"
      w="full"
      h="70px"
      py="s3"
      px="s6"
    >
      <c.Flex gap="s2" align="center">
        <MenuDrawerV2 isOpen={isOpen} onClose={onClose} onToggle={onToggle} />
        <c.Button
          bg="transparent"
          _hover={{ backgroundColor: 'transparent' }}
          _focus={{ backgroundColor: 'transparent' }}
          cursor="pointer"
          onClick={() => navigate('/')}
        >
          <c.Icon as={HousiLogoIconMobile} />
        </c.Button>
      </c.Flex>

      <SearchButton
        bg="black.100"
        label="Buscar"
        maxHeight="32px"
        width="fit-content"
        pt="s1"
        pr="s1"
        pb="s1"
        pl="s3"
      />
    </c.Flex>
  )
}
export default NavbarMobile
